import { useState } from "react";
import { Play } from "lucide-react";
import { youtubeId } from "../../lib/core";
import { GoldLogo } from "./ui";

const LABEL = "Watch: Sandeep explains what happens at the Summit (1 min)";

export const LiteYouTube = ({ url, label = LABEL, testid = "video-container", priority = true }) => {
  const id = youtubeId(url);
  const [playing, setPlaying] = useState(false);
  const [thumb, setThumb] = useState(0);
  const thumbs = id ? [`https://i.ytimg.com/vi_webp/${id}/hqdefault.webp`, `https://i.ytimg.com/vi/${id}/hqdefault.jpg`] : [];

  return (
    <div className="gold-border shadow-[0_0_80px_-20px_rgba(212,175,55,.55)]">
      <div data-testid={testid} className="relative aspect-video w-full overflow-hidden rounded-[19px] bg-black">
        {playing && id ? (
          <iframe
            title="Wealth Code Summit video"
            src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&modestbranding=1&playsinline=1`}
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
            className="absolute inset-0 h-full w-full"
          />
        ) : (
          <button
            type="button"
            data-testid={`${testid}-play`}
            onClick={() => id && setPlaying(true)}
            aria-label={id ? label : "Video coming soon"}
            className="group absolute inset-0 h-full w-full text-left"
          >
            {id && thumb < 2 ? (
              <img
                src={thumbs[thumb]}
                onError={() => setThumb((t) => t + 1)}
                onLoad={(e) => e.currentTarget.naturalWidth <= 120 && setThumb((t) => t + 1)}
                alt={label}
                fetchpriority={priority ? "high" : "low"}
                loading={priority ? "eager" : "lazy"}
                width="480"
                height="360"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105"
              />
            ) : (
              <div className="absolute inset-0 bg-[radial-gradient(80%_70%_at_50%_30%,#2a2210_0%,#0A0A0A_75%)]">
                <GoldLogo className="absolute right-5 top-5 h-10 w-10 opacity-90" />
                <span className="label-xs absolute left-5 top-6 text-[#D4AF37]">{id ? "Wealth Code Summit" : "Video coming soon"}</span>
              </div>
            )}
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
            <span className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center">
              <span className="pulse-ring absolute h-20 w-20 rounded-full bg-[#D4AF37]/40 sm:h-24 sm:w-24" />
              <span className="btn-gold relative flex h-20 w-20 items-center justify-center rounded-full sm:h-24 sm:w-24">
                <Play className="ml-1 h-8 w-8 fill-[#0A0A0A] sm:h-10 sm:w-10" />
              </span>
            </span>
            <span className="absolute bottom-4 left-4 right-4 text-sm font-semibold text-[#F5F0E6] sm:bottom-5 sm:left-6 sm:text-base">{label}</span>
          </button>
        )}
      </div>
    </div>
  );
};
